/**
 * The theme context's shape and the context itself, apart from ThemeProvider
 * so components can import the type without pulling in the provider (and so
 * React Fast Refresh keeps a file of only components).
 *
 * Read with shared/hooks/useTheme (Header's theme switch, TooltipContext,
 * useTemperatureTheme). 'garden' and 'almanac' were themes once; a saved
 * one of those is read as Grow (utils/themeUtils normaliseTheme).
 *
 * @module ThemeContext
 */
import { createContext } from 'react';

/** Available theme options for the application */
export type Theme = 'grow' | 'light' | 'dark' | 'fieldnotes';

/** 
 * Theme context type definition
 * @interface
 */
export interface ThemeContextType {
  /** Current active theme */
  theme: Theme;
  /** Function to update the current theme */
  setTheme: (theme: Theme) => void;
}

/** Context for managing application theme state */
export const ThemeContext = createContext<ThemeContextType | undefined>(undefined); 